import { render, staticRenderFns } from "./BuildingStatistics.vue?vue&type=template&id=56195bf4&scoped=true&"
import script from "./BuildingStatistics.vue?vue&type=script&lang=js&"
export * from "./BuildingStatistics.vue?vue&type=script&lang=js&"
import style0 from "./BuildingStatistics.vue?vue&type=style&index=0&id=56195bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56195bf4",
  null
  
)

export default component.exports